var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"images-slider-hotel",on:{"click":function($event){return _vm.$emit('slider-hotel-click')}}},[_c('images-slider',{attrs:{"selected-index":_vm.selectedIndex,"images":_vm.sizedImages,"thumbs":_vm.isVisibleThumbs ? _vm.thumbs : [],"video":_vm.video,"isShouldShowPhotosCounter":true,"navigation-size":"large","breakpoints":{
            0: {
                slidesPerView: 16,
            },
            1240: {
                slidesPerView: 9,
            },
            1440: {
                slidesPerView: 10,
            },
        }},on:{"is-end":function($event){return _vm.setIsWatchGalleryUntilTheEnd(true)},"thumb-click":function($event){return _vm.setIsClickedOnThumb(true)},"slide-changed":(index) => _vm.slideChangeHandler(index),"big-image-click":function($event){return _vm.$emit('openFullscreenSlider', _vm.selectedIndex)}}}),_vm._v(" "),_c('div',{staticClass:"images-slider-hotel__zoom",on:{"click":function($event){return _vm.$emit('openFullscreenSlider', _vm.selectedIndex)}}},[_c('img',{attrs:{"src":require("./img/Zoom.svg"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }